<div class="page">
    <div class="layout">
        <div class="left-side">
            <img class="logo" src="../../../assets/images/logo2.svg" alt="" />
           <div class="vector-layer">
            <img class="left-image" src="../../../assets/vectors/auth-vector1.svg" alt="">
           </div>
            <div class="base-layer">
                <span class="base-title">One Card Many Solutions</span>
                <span class="base-label">
                  Sudo is an open API platform that lets you embed powerful financial
                  features into your product. Build in minutes, launch in days.
                </span>
            </div>
        </div>
        <div class="right-side">
            <img class="logo" src="../../../assets/images/logo.svg" alt="" />
            <div class="form-holder">
                <div class="form-container">
                    <h1>Password Update</h1>
                    <p>Kindly provide your registered email address and new password.</p>
                    <app-error-message [message]="errorMessage"></app-error-message>
                    <div class="form">
                        <div><app-input (dataEvent)="email($event)" label="Email Address" placeholder="Enter your email"></app-input></div>
                        <div><app-input (dataEvent)="password($event)" type="password" label="New Password" placeholder="Enter new password"></app-input></div>
                        <div><app-input (dataEvent)="checkPassword($event)" label="Confirm Password" placeholder="Re-enter password"></app-input></div>
                        <!-- <div><p class="forgot" (click)="forgotPassword()">forgot password?</p></div> -->
                        <!-- <app-button-fill buttonText="Login" (loginClick)="login()"></app-button-fill> -->
                        <app-button-fill [processLoading]="processLoading" [action]="updatePassword" buttonText="Send"></app-button-fill> 
                        <!-- <div class="create-account"><p> <a (click)="login()" class="login-link">Login →</a></p></div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

